<template>
  <!-- 小程序view替换为Web标准div，保留核心class -->
  <div class="break-container">第{{ page }}页</div>
</template>

<script>
export default {
  name: "PageTitle",
  // Vue2 定义Props（与原Vue3 props完全一致）
  props: {
    params: {
      type: Object,
      default: () => ({}), // 对象默认值用函数避免引用共享
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dataObj: {},
      page: "",
    };
  },
  // Vue2 监听属性（保留原逻辑的immediate和deep）
  watch: {
    // 监听dataObj变化（核心逻辑）
    params: {
      handler(newValue) {
        console.log("newValueyyyyyyyyyyyyy", newValue);
        this.dataObj = { ...newValue.data }; // 深拷贝避免引用问题
        this.page = newValue.data.pageLineIndex || ""; // 容错：空值时显示空字符串
      },
      immediate: true, // 初始化立即执行
      deep: true, // 深度监听对象内部变化
    },
    // // 监听index变化
    // "props.index": {
    //   handler(newValue) {
    //     console.log("newValue", newValue);
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    // // 监听updateType变化
    // "props.updateType": {
    //   handler(newValue) {
    //     this.updateType = newValue;
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
};
</script>

<style lang="scss" scoped>
.break-container {
  /* rpx转px：1rpx = 0.5px，适配Web端 */
  width: 100%; /* 710rpx → 355px，Web端也可改用width: 95% 提升自适应 */
  margin: 0 auto; /* 居中保留 */
  padding: 9.5px 12.5px; /* 19rpx 25rpx → 9.5px 12.5px */
  box-sizing: border-box; /* 盒模型保留 */
  border-top: 1px dashed #3a60ff; /* 2rpx → 1px，虚线样式保留 */
  text-align: center; /* 文字居中保留 */
  color: #2b2f36; /* 文字颜色保留 */
  font-size: 14px; /* 28rpx → 14px，Web端常规字体大小 */

  /* 可选：Web端自适应优化（推荐） */
  /* width: 95%; */
  /* max-width: 710px; */
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewPageBreak.vue